import { Flex, ReadonlyField, Text } from '@shared/components';
import { type FieldValues } from 'react-hook-form';

import { type BaseInputModeProps } from '../../types';
import { AttachedFilePreview, type AttachedFilePreviewProps } from '../attached-file-preview';
import { FormFilesInput, type FormFilesInputProps } from '../form-files-input';

type InputModeProps = BaseInputModeProps<Omit<FormFilesInputProps<FieldValues>, 'name'>>;

interface ViewModeProps {
  mode: 'view';
  slotProps: AttachedFilePreviewProps & { label?: string };
}

export type FileInputRendererProps = InputModeProps | ViewModeProps;

export default function FileInputRenderer(props: Readonly<FileInputRendererProps>) {
  switch (props.mode) {
    case 'input': {
      const { name, slotProps } = props;

      return <FormFilesInput name={name} {...slotProps} />;
    }
    case 'view': {
      const { slotProps } = props;

      return (
        <Flex sx={(theme) => ({ gap: theme.spacing(2), flexDirection: 'column' })}>
          <Text component='span' variant='captionSemibold'>
            {slotProps.label ?? ''}
          </Text>
          {slotProps.files.length > 0 ? (
            <AttachedFilePreview {...slotProps} />
          ) : (
            <ReadonlyField content='-' />
          )}
        </Flex>
      );
    }
  }
}
